/* ============================================================
   cart-count.js — Badge con el número de productos en el carrito.
   Círculo en la esquina superior derecha del icono del carrito.
   Se actualiza al agregar (escucha eventos del theme + bkp:cart:refresh).
   Muestra 0 si el carrito está vacío.
   ============================================================ */
(function () {
  'use strict';

  function ensureBadges() {
    document.querySelectorAll('.cart__toggle').forEach(function (toggle) {
      if (toggle.querySelector('[data-cart-count]')) return;
      var b = document.createElement('span');
      b.className = 'cart-count-bubble';
      b.setAttribute('data-cart-count', '');
      b.setAttribute('aria-hidden', 'true');
      b.textContent = '0';
      toggle.appendChild(b);
    });
  }

  function setCount(n) {
    ensureBadges();
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = n;
    });
    document.querySelectorAll('.cart__toggle').forEach(function (t) {
      t.classList.toggle('cart__toggle--has-items', n > 0);
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count || 0); })
      .catch(function () {});
  }

  // Expuesto por si otro script quiere forzar la actualización
  window.bkpUpdateCartCount = refresh;

  function init() {
    ensureBadges();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['theme:cart:added', 'theme:cart:add', 'theme:cart:update', 'theme:cart:change', 'bkp:cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });
})();
